import { Fragment, useState } from 'react';
import styled, { css } from 'styled-components';

import {
  HubSelector,
  HubSelectorMobile,
  InteractiveMap,
} from '@components/molecules';
import { Hub } from '@shared/enums/hub';
import useDevice from '@hooks/useDevice';
import { device } from '@styles/mediaQuery';

function Map() {
  const [hub, setHub] = useState(Hub.Chicago);
  const { isMobile, isTablet, isLaptop, isDesktop } = useDevice();

  return (
    <Fragment>
      {(isMobile || isTablet) && (
        <HubSelectorMobile hub={hub} setHub={setHub} />
      )}

      <MapWrapper>
        <Container>
          <InteractiveMap hub={hub} setHub={setHub} />

          {(isLaptop || isDesktop) && <HubSelector hub={hub} setHub={setHub} />}
        </Container>
      </MapWrapper>
    </Fragment>
  );
}

const Container = styled.div`
  position: relative;

  width: 100%;

  max-width: 1240px;
  margin: 0 auto;

  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid ${({ theme }) => theme.colors.divider};
  border-radius: 12px;
  overflow: hidden;

  height: 343px;

  ${device.mobileL(css`
    height: 400px;
  `)}

  ${device.tablet(css`
    height: 450px;
  `)}
  
  ${device.laptopS(css`
    height: 100%;
    border-radius: 0;
    border: 0;
  `)}
`;

const MapWrapper = styled.div`
  width: 100%;
  padding: 20px;

  ${device.laptopS(css`
    padding: 50px;
    background-color: ${({ theme }) => theme.colors.cardBackground};
  `)}
`;

export default Map;
